import { FC, ComponentProps } from 'react';
import * as Flowbite from 'flowbite-react';
import { RefObject } from 'react';
import { BaseInputProps } from '../types';
import { theme } from './theme';

type TextareaProps = BaseInputProps &
    Omit<Flowbite.TextareaProps, 'onChange'> & {
        ref?: RefObject<HTMLTextAreaElement>;
        // This one is just placeholder, because we're using it within FormInput
        // And all of FormInput cases component supports rightIcon, except this
        // one. This already breaks ResetInput. Unfortunately new fallbacks like
        // this required to be added here, when using some of FormInput props
        rightIcon?: FC<ComponentProps<'svg'>>;
    };

export const Textarea = ({
    onChange = () => {},
    label,
    color = 'primary',
    ref,
    ...props
}: TextareaProps) => (
    <Flowbite.Label className="flex flex-col gap-2 font-normal" color={color}>
        {label && <span className="font-medium">{label}</span>}
        <Flowbite.Textarea
            theme={theme}
            {...props}
            ref={ref}
            color={color}
            onChange={(e) => onChange(e.target.value)}
        />{' '}
    </Flowbite.Label>
);
Textarea.displayName = 'Textarea';
